export function getHeaders(authToken) {
  return {
    'x-an-webservice-customerauthtoken': authToken,
  };
}
